<template>
    <iframe
        id="page_frame"
        name="page_frame"
        style="width: 100%; height: 700px; border: none; margin-top: -84px"
    ></iframe>
    <form v-if="url" id="frmLoadPage" method="post" :action="`${url}/main/${action}`" target="page_frame">
        <input type="hidden" name="userid" :value="$store.user.userId.toString()" />
        <input type="hidden" name="hash" :value="hash" />
        <input type="hidden" name="dice" :value="dice.toString()" />
        <input type="hidden" name="datetime" :value="datetime.toString()" />
        <input type="hidden" name="organisationid" :value="$store.user.orgId.toString()" />
        <input type="hidden" name="VIEW_RTIB_REPORTS" :value="$store.hasRight('VIEW_RTIB_REPORTS') ? '1' : '0'" />
        <input type="hidden" name="EDIT_RTIB_REPORTS" :value="$store.hasRight('EDIT_RTIB_REPORTS') ? '1' : '0'" />
        <input type="hidden" name="EDIT_RTIB_EMAILS" :value="$store.hasRight('EDIT_RTIB_EMAILS') ? '1' : '0'" />
        <input type="hidden" name="GLOBAL_SETTINGS" :value="$store.hasRight('GLOBAL_SETTINGS') ? '1' : '0'" />
    </form>
</template>

<script>
    import { load } from '@/utils/Http';
    export default {
        name: 'BillingPage',
        props: {
            action: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                datetime: null,
                dice: null,
                hash: null,
                url: null,
            };
        },
        created() {
            this.loadFrame();
        },
        methods: {
            loadFrame() {
                window.clearStatusMessage = () => {
                    this.$store.hideStatusMessage();
                };
                window.displaySuccessMessage = (text) => {
                    this.$store.showSuccessMessage(text);
                };
                window.displayErrorMessage = (text) => {
                    this.$store.showErrorMessage(text);
                };
                window.clearStatusPanel = () => {
                    this.$store.hideLoadingOverlay();
                };
                window.displayStatusLoading = () => {
                    this.$store.setShowLoadingOverlay('Loading...');
                };
                window.displayStatusSaving = () => {
                    this.$store.setShowLoadingOverlay('Saving...');
                };
                window.displayStatusDeleting = () => {
                    this.$store.setShowLoadingOverlay('Deleting...');
                };

                load('billing/url', {}, (response) => {
                    this.datetime = response.datetime;
                    this.dice = response.dice;
                    this.hash = response.hash;
                    this.url = response.url.replace('{server.name}', window.location.host);
                    this.$nextTick(() => {
                        document.getElementById('frmLoadPage').submit();
                    });
                });
            },
        },
    };
</script>
